import * as ph from "./posthog";

function withTimestamp<T extends Record<string, unknown>>(props: T) {
  return { ...props, timestamp: new Date().toISOString() };
}

// Note: "User Signed Up" is fired server-side from the Clerk webhook so it
// can never duplicate (localStorage-based client dedupe was leaky in
// private-browsing / multi-tab sessions).

export function identifyUser(userId: string, properties?: Record<string, unknown>) {
  ph.identify(userId, properties);
}

export function trackViewContent(
  pageName: string,
  userId?: string,
  props?: Record<string, unknown>,
) {
  ph.capture(
    "Page Content Viewed",
    withTimestamp({
      page_name: pageName,
      user_id: userId,
      page: window.location.pathname,
      ...props,
    }),
  );
}

export function trackAddToCart(
  userId: string,
  packageId: string,
  value: number,
  source = "billing_page",
  currency = "USD",
) {
  ph.capture(
    "Add to Cart",
    withTimestamp({
      user_id: userId,
      package_id: packageId,
      value,
      currency,
      source,
    }),
  );
}

export function trackInitiateCheckout(
  userId: string,
  packageId: string,
  value: number,
  source = "billing_page",
  currency = "USD",
) {
  ph.capture(
    "Checkout Initiated",
    withTimestamp({
      user_id: userId,
      package_id: packageId,
      value,
      currency,
      source,
    }),
  );
}

export function trackImageUploaded(props: Record<string, unknown>) {
  ph.capture("Image Uploaded", withTimestamp(props));
}

export function trackCreditsModalShown(props: Record<string, unknown>) {
  ph.capture("Credits Modal Shown", withTimestamp(props));
}

export { registerGlobals } from "./posthog";
